import { render, staticRenderFns } from "./GalleryEdit.vue?vue&type=template&id=b0464b9c&"
import script from "./GalleryEdit.vue?vue&type=script&lang=js&"
export * from "./GalleryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0464b9c')) {
      api.createRecord('b0464b9c', component.options)
    } else {
      api.reload('b0464b9c', component.options)
    }
    module.hot.accept("./GalleryEdit.vue?vue&type=template&id=b0464b9c&", function () {
      api.rerender('b0464b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GalleryEdit.vue"
export default component.exports